const mtnpulseTNC = {
  header: "MTN Pulse Privacy Policy",
  body: [
    {
      title: "MTN PULSE ENHANCEMENT TO YOUR PRIVACY",
      details:
        "MTN propriety Limited, Registration number: 1993/001411/07 ‘MTN’respects the privacy of our customer’s personal information that the customers provide us with and should be protected through the use and interaction with the www.mtn.co.za website and all associated website, mobile application, product and services. We have prepared this MTN customer Privacy policy and notice “this policy” to notify you of what type of personal information we collect from you and our customers and / or users, how we will treat that personal information and the circumstances under which we will share it with third parties.",
    },
    {
      title: `WHO IS THE MTN PULSE CUSTOMER`,
      details: `An MTN pulse customer is a natural person (individual) between the
      ages of 18 – 34 years, who enters into a contract with MTN or any MTN
      Affiliate for the receipt of service or product for its own use (as
      part of an integrated solution provided by MTN or any Affiliate).
      Customers who act on behalf of an organization may only use the MTN
      Pulse application, Microsite, products and services with the
      authorization from the organization. Customers who are natural persons
      and are under 18 years may only use the MTN pulse mobile application,
      Microsite, product and service with the involvement of a parent or
      guardian who has provided consent for them`,
    },
    {
      title: "WHO IS THE USER",
      details: ` A user is a person (individual or organization) who uses the MTN Pulse
      application, Microsite, product and services.`,
    },
    {
      title: "CONSENT FROM YOU",
      details: ` MTN will not collect or process customer and / or user personal
      information without obtaining the customer and / or user’s consent.
      Your consent is obtained in the terms and conditions. (for example,
      MTN Pulse Subscriber Agreements, Pre – paid terms and Conditions,
      Master Service/Reseller Agreements and Registration or signing up of
      any MTN online services and products and this policy) By accepting the
      above-mentioned term and conditions, you are accepting the terms and
      conditions of this Privacy Policy and providing MTN with the consent
      for the processing of your personal information and accepting the
      practices described in this policy.`,
    },
    {
      title: `WHO DOES THIS POLICY APPLY TO`,
      details: ` This policy applies to: All MTN Pulse customers and / or users who are
      natural persons All MTN pulse customers and / or users who are
      organization That uses MTN Pulse Microsite, mobile Application,
      product or services.`,
    },
  ],
};

export default mtnpulseTNC;
